import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faCartArrowDown, faChartPie, faChevronDown, faClipboard, faCommentDots, faFileAlt, faPlus, faRocket, faStore } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Button, Dropdown } from '@themesberg/react-bootstrap';
import { ChoosePhotoWidget, ProfileCardWidget } from "../components/Widgets";
import { GeneralInfoForm } from "../components/Forms";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb } from '@themesberg/react-bootstrap';

import { SoftBranchTable } from "../components/Tables";
import { Link } from 'react-router-dom';

import Profile3 from "../assets/img/team/profile-picture-3.jpg";


export default () => {
  return (
    <>

      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">

        <div className="my-auto">
          <h2 className="page-breadcrumb">Deleted Records</h2>
        </div>

        <Link to="/branches">
          <Button variant="primary" className="btn-quote-blue d-inline-flex align-items-center py-2 px-3 btn btn-primary box-shedow-none outline-none btn btn-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
            Back To Branch listing
          </Button>
        </Link>

      </div>

      <div className="my-auto">
        <SoftBranchTable />
      </div>

    </>
  );
};